// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dropdown-buttons.dropdown-toggle::after {
    display: inline-block !important;
}

.actionIcon {
  margin-bottom: 0.5rem;
  cursor: pointer;
  color: var(--secondary-color);
}

.actionIcon:hover {
  color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/features/StudyDetails/components/EvidenceVariableButtons/EvidenceVariableButtons.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["#dropdown-buttons.dropdown-toggle::after {\r\n    display: inline-block !important;\r\n}\r\n\r\n.actionIcon {\r\n  margin-bottom: 0.5rem;\r\n  cursor: pointer;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.actionIcon:hover {\r\n  color: var(--primary-color);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
